import { createFileRoute } from "@tanstack/react-router";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import { z } from "zod";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { UserCog, Mail, Shield } from "lucide-react";

export const Route = createFileRoute("/admin/users")({
  component: UsersPage,
});

function UsersPage() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({
    queryKey: ["users"],
    queryFn: () => apiFetch("/api/config/users", { schema: z.object({ items: z.array(z.any()) }) }).catch(() => ({ items: [] })),
  });

  return (
    <div className="space-y-4 p-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <UserCog className="h-5 w-5" /> Utilisateurs
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">RBAC · MFA · Provisioning</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Membres</CardTitle>
          <CardDescription>{data?.items.length ?? 0} utilisateurs dans cet établissement</CardDescription>
        </CardHeader>
        <CardContent>
          {isLoading ? (
            <Skeleton className="h-32 w-full" />
          ) : (
            <ul className="space-y-2">
              {data?.items.map((u: any) => (
                <li key={u.id} className="flex items-center justify-between rounded-md border border-white/5 bg-white/[0.02] p-3">
                  <div>
                    <div className="font-medium">{u.displayName ?? u.email}</div>
                    <div className="mt-1 flex items-center gap-2 text-xs text-muted-foreground">
                      <Mail className="h-3 w-3" /> {u.email}
                      <Shield className="h-3 w-3" /> {u.role}
                    </div>
                  </div>
                  <Badge variant={u.active ? "secondary" : "outline"}>{u.active ? "Actif" : "Inactif"}</Badge>
                </li>
              ))}
            </ul>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
